import track from 'analytics/track';

/**
 * Calls the Expand Reviews Breakdown event when a user opens the reviews popover in the purchaser of the PDP.
 * @param {string} productCategory the product category of the PDP's respective product
 * @param {number} avgRating The average rating from that popover's respective product reviews
*/
export const showReviewsPopover = (productCategory, avgRating) => {
  const trackParams = {
    params: {
      ga: {
        eventAction: `Expand Reviews Breakdown`,
        eventCategory: productCategory,
        eventLabel: `Shop Module`,
        nonInteraction: true,
      },
      heap: {
        eventName: `Expand Reviews Breakdown`,
        properties: {
          [`current_rating`]: avgRating,
          category: productCategory,
        },
      },
    },
  };
  track(trackParams);
};

/**
  Calls promo impressions for the reviews module
  * @param {string} placement Where the review module was viewed
*/
export const reviewModuleImpression = (placement) => {
  const trackParams = {
    params: {
      ga: {
        eventAction: `Reviews Module Impression`,
        eventCategory: `Reviews`,
        eventLabel: placement,
      },
      heap: {
        eventName: `Reviews - Reviews Module Impression`,
        properties: {
          placement,
        },
      },
    },
  };
  track(trackParams);
};

/**
  Calls click event for the "See All Reviews" CTA on reviews module
  * @param {string} placement Where the review module was viewed
*/
export const reviewModuleClick = (placement) => {
  const trackParams = {
    params: {
      ga: {
        eventAction: `Reviews Module Clicks`,
        eventCategory: `Reviews`,
        eventLabel: placement,
      },
      heap: {
        eventName: `Reviews - Reviews Module Clicks`,
        properties: {
          placement,
        },
      },
    },
  };
  track(trackParams);
};

/**
  Calls click event for the "Submit Reviews" review composer page
  * @param {string} productCategory product being reviewed
  * @param {number} rating rating of the product being reviewed
*/
export const reviewComposerSubmit = (productCategory, rating) => {
  const trackParams = {
    params: {
      ga: {
        eventAction: `Review Submitted`,
        eventCategory: productCategory,
        eventLabel: rating,
      },
      heap: {
        eventName: `Review Submitted`,
        properties: {
          category: productCategory,
          [`star_rating`]: rating,
        },
      },
    },
  };
  track(trackParams);
};
